import React from "react";

const ReportsProduct = ()=>{

    return <h1>Reports Product</h1>
}

export default ReportsProduct;